<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">治安查询</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="治安类型">
            <el-select v-model="SecurityType" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in SecurityTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
              unlink-panels
            ></el-date-picker>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <!-- <div class="zj-button-bar">
          <el-button v-if="isAdd" size="mini" @click="onAdd">填 报</el-button>
        </div> -->
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-loading="loading"
              element-loading-text="搜索中"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              >
              </el-table-column>
             
              <el-table-column
                prop="ReportTime"
                label="填报日期"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
               <el-table-column
                prop="SecurityType"
                label="治安类型"
                :formatter="SecurityTypeNumToNameConverter"
              ></el-table-column>
              <el-table-column
                prop="SecurityLevel"
                label="治安等级"
              ></el-table-column>
              <el-table-column prop="Extends1" label="地点"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="LookDetail(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                
                  <!-- <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import moment from "moment";
// import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

export default {
  name: "SecurityList",
  controller: "UI",
  action: "SecurityList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Sender: "",
      date: [new Date(new Date() - 90 * 24 * 60 * 60 * 1000), new Date()],
      isAdd: true,
      curDate: "",
      dialogVisible: false,
      loading: false,
      IsAdministrator: false,
      loadingText: "加载中...",
      SecurityType:"",
      SecurityTypeArr:[]
    };
  },
  created: function () {
   
  },
  mounted: function () {
    this.getSecurityType();
    this.search();
   // this.GetUserIsAdministrator();
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
     getSecurityType() {
      //预警类型
      this.config
        .getUValue("cyjc:SecurityType", "")
        .then((d) => {
          this.SecurityTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let searchInfo = {
         SecurityType: this.SecurityType,
        // CompanyId: this.IsAdministrator ? "" : this.user.Departments[0].OrgId,
        ReportStartTime: this.date.length==0 ? null : new Date(this.date[0]).format("yyyy-MM-dd"),
        ReportEndTime: this.date.length==0 ? null : new Date(this.date[1]).format("yyyy-MM-dd"),
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      new MyApis.TbTourSecurityApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          let data = r.data;
          if (data.RspCode === "1") {
            this.tableData = [];
            if (data.Data && data.Data.PageContents.length > 0) {
              this.tableData = data.Data.PageContents.map((item) => {
                item.ReportTime = moment(item.ReportTime).format("YYYY-MM-DD");
                
                return item;
              });
              this.total = data.Data.BaseSearch.TotalCount;
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.SecurityType = "";
      this.date = [new Date(new Date() - 90 * 24 * 60 * 60 * 1000), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/TravelCarAdd",
        query: {
          type: "add",
        },
      });
    },
    LookDetail(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/SecurityAdd",
        query: {
          InfoId: row.ID,
          type: "look",
        },
      });
    },
    EditDetail(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/TravelCarAdd",
        query: {
          InfoId: row.ID,
          type: "edit",
        },
      });
    },
    
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.TbTourTravelCarApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    },
    SecurityTypeNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const SecurityTypeName = this.SecurityTypeArr.map((item) => {
        if (item.ItemValue == data) return item.Description;
      }).join("");
      if (SecurityTypeName == null || SecurityTypeName == "") {
        return data;
      }
      return SecurityTypeName;
    },
  },
};
</script>
<style lang="scss">
</style>